import { Injectable } from '@angular/core';

import { PropertiesService } from './properties.service';
import { RegionService } from './region.service';

@Injectable({ providedIn: 'root' })
export class ExternalLinksService {

  constructor(
    private propertiesService: PropertiesService,
    private regionService: RegionService,
  ) { }

  getUserProfileUrl(): string {
    return <string>this.propertiesService.get('userProfileUrl');
  }

  getPrivacyPolicyUrl(): string {
    const countryCode = this.regionService.getCountryCode();
    return <string>this.propertiesService.get(`privacyPolicyUrl${countryCode}`);
  }

  getCustomerServiceUrl(): string {
    const countryCode = this.regionService.getCountryCode();
    return <string>this.propertiesService.get(`customerServiceUrl${countryCode}`);
  }

  getTermsUrl(): string {
    const countryCode = this.regionService.getCountryCode();
    return <string>this.propertiesService.get(`termsUrl${countryCode}`);
  }

  getWinnersListUrl(): string {
    const countryCode = this.regionService.getCountryCode();
    return <string>this.propertiesService.get(`winnersListUrl${countryCode}`);
  }

  getFaqUrl(): string {
    const countryCode = this.regionService.getCountryCode();
    return <string>this.propertiesService.get(`faqUrl${countryCode}`);
  }

  getGooglePlayAppUrl(): string {
    return <string>this.propertiesService.get('googlePlayAppUrl');
  }

  getSiteAddres() {
    const loc = window.location;
    return loc.protocol + '//' + loc.host;
  }
}
